import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["read", "handleActiveChange", "onToggle", "testId", "groupReadStates", "triggerRef"];
import React from 'react';
import { useIntl } from 'react-intl-next';
import { B400 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { ReadState } from '@atlassian/notification-types/types';
import messages from '../../../utils/i18n/messages';
import { UnreadIndicatorWrapper } from './styled';
import UnreadIndicator from './unread-indicator';
function ReadStateIndicator(_ref) {
  var read = _ref.read,
    handleActiveChange = _ref.handleActiveChange,
    onToggle = _ref.onToggle,
    testId = _ref.testId,
    _ref$groupReadStates = _ref.groupReadStates,
    groupReadStates = _ref$groupReadStates === void 0 ? [] : _ref$groupReadStates,
    triggerRef = _ref.triggerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var label = read ? intl.formatMessage(messages.markNotificationAsUnread) : intl.formatMessage(messages.markNotificationAsRead);
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: label,
    position: "left",
    testId: "read-state-tooltip"
  }, /*#__PURE__*/React.createElement(UnreadIndicatorWrapper, _extends({
    ref: triggerRef
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "notification-list__unread-indicator-wrapper",
    "data-testid": testId ? testId : 'mark-as-read-button',
    onClick: onToggle,
    onMouseDown: function onMouseDown() {
      return handleActiveChange(true);
    },
    onMouseUp: function onMouseUp() {
      return handleActiveChange(false);
    },
    "aria-pressed": read
    // Do not change aria-label as it is coupled with aria-pressed to indicate button state
    ,
    "aria-label": intl.formatMessage(messages.markNotificationAsRead)
  }, props), /*#__PURE__*/React.createElement(UnreadIndicator, {
    fillColour: read && !groupReadStates.includes(ReadState.UNREAD) ? 'none' : "var(--ds-icon-brand, ".concat(B400, ")"),
    halfFill: read && groupReadStates.includes(ReadState.UNREAD)
  })));
}
export default ReadStateIndicator;